import React from 'react'
import ReactSelect from 'react-select'
import styles from './FontFamilyInput.module.css'

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    background: 'var(--white)',
    borderColor: 'var(--washed-gray)',
    minHeight: '28px',
    height: '28px',
    boxShadow: state.isFocused ? null : null,
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    height: '28px',
    padding: '0 6px',
  }),
  input: (provided, state) => ({
    ...provided,
    margin: '0px',
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1
    const transition = 'opacity 300ms'

    return {
      ...provided,
      opacity,
      transition,
      color: 'var(--dark-gray)', // Changer la police du texte du singleValue
      fontSize: 'var(--size-font-input)',
      fontWeight: '400',
      fontFamily: state.data.value, // Changer la taille du texte du singleValue
    }
  },
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused
      ? 'var(--darkened-background)'
      : 'var(--white)', // Changer la couleur d'arrière-plan de l'option
    color: state.isFocused ? 'var(--dark-gray)' : 'var(--dark-gray)',
    fontFamily: state.data.value, // Changer la couleur du texte de l'option
  }),
  menu: (provided, state) => ({
    ...provided,
    backgroundColor: 'var(--white)', // Changer la couleur de fond du menu déroulant
  }),
  indicatorSeparator: (state) => ({
    display: 'none',
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    height: '28px',
  }),
}

const FontFamilyInput = ({ name, value, onChange }) => {
  // Définir vos options de police ici
  const fontFamilies = [
    'Arial',
    'Courier New',
    'Georgia',
    'Inter',
    'Montpellier',
    'Montserrat',
    'MuseoModerno',
    'Open Sans',
    'Poppins',
    'SF Pro Display',
    'Times New Roman',
    'Verdana',
  ]

  const options = fontFamilies.map((font) => ({
    value: font,
    label: font,
  }))

  const handleChange = (selectedOption) => {
    // Assurez-vous que l'événement onChange reçoit un objet qui imite un événement de changement d'entrée HTML standard
    onChange({
      target: {
        name: name,
        value: selectedOption ? selectedOption.value : '',
      },
    })
  }

  const selectedOption = options.find((option) => option.value === value)

  return (
    <div className={styles.container}>
      <ReactSelect
        value={selectedOption}
        onChange={handleChange}
        options={options}
        className={styles.select}
        styles={customStyles}
      />
    </div>
  )
}

export default FontFamilyInput
